import { ReactNode } from 'react'

import { ReportCard } from './reportsConfig'
import { usePostHogFeatureFlag } from '@percent/partner-dashboard/common/hooks'
import { PostHogFeatureFlag } from '@percent/partner-dashboard/common/hooks/usePostHogFeatureFlag/posthogFeatureFlags'

type ReportFlagGateProps = {
  report: ReportCard
  children: ReactNode
  fallback?: ReactNode
}

function FlaggedReport({
  flag,
  children,
  fallback
}: Readonly<{ flag: PostHogFeatureFlag; children: ReactNode; fallback: ReactNode }>) {
  return usePostHogFeatureFlag(flag) ? children : fallback
}

/** Renders a report only while its rollout flag, if it has one, is on. */
export function ReportFlagGate({ report, children, fallback = null }: Readonly<ReportFlagGateProps>) {
  if (!report.featureFlag) return children

  return (
    <FlaggedReport flag={report.featureFlag} fallback={fallback}>
      {children}
    </FlaggedReport>
  )
}
